import { useMemo } from "react";
import queryString from "query-string";
import { useLocation } from "react-router-dom";

export const useSearchParams = (module = "") => {
    let { search, hash } = useLocation();
    if (hash && hash.length > 0) {
        search = `${search}${hash.replaceAll("#", "%23")}`
    }
    return useMemo(() => {
        let result = queryString.parse(search, { parseBooleans: false, parseNumbers: false });
        if (module === "tracker") {
            if (result["branch_code"]) {
                result["branch_codes"] = result["branch_code"];
                delete result["branch_code"];
            }
        }
        return result;
    }, [ search, module ]);
};
